import { render, staticRenderFns } from "./CatalogLink.vue?vue&type=template&id=7108dc08&"
import script from "./CatalogLink.vue?vue&type=script&lang=js&"
export * from "./CatalogLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports